import Wagenbuch from './Wagenbuch.vue';
import WagenbuchHeader from './WagenbuchHeader.vue';
import SchadenFormular from './wb-config/SchadenFormular.vue';
import SchadenFormularHeader from './wb-config/SchadenFormularHeader.vue';
import WagenbuchEreignis from './WagenbuchEreignis.vue';
import WagenbuchEreignisHeader from './WagenbuchEreignisHeader.vue';
import moduleId from './moduleId';

class WagenbuchRouteHandler {
  getRoutes = ({ moduleType }) => {
    return [
      {
        path: '/wagenbuch/:fzId?',
        name: 'wagenbuch',
        meta: { moduleType, initiateSyncBeforeNav: true, moduleId, baseRoute: true },
        components: { default: Wagenbuch, header: WagenbuchHeader },
      },
      {
        path: '/wagenbuch-ereignis/:fzId?',
        name: 'ereignis',
        meta: { moduleType, initiateSyncBeforeNav: false, moduleId, baseRoute: false },
        components: { default: WagenbuchEreignis, header: WagenbuchEreignisHeader },
      },
      {
        path: '/wagenbuch-schaden/:wbType/:fzId?',
        name: 'schadenformular',
        meta: { moduleType, initiateSyncBeforeNav: false, moduleId, baseRoute: false },
        components: { default: SchadenFormular, header: SchadenFormularHeader },
      },
    ];
  };
}
const routeHandler = new WagenbuchRouteHandler();
export default routeHandler;
